/**
 * Implements a Behavior to enable metisMenu, a jQuery plugin on a menu
 * See: https://github.com/onokumus/metisMenu
 */

import Marionette from "backbone.marionette";
import "metismenu";

class MetisMenu extends Marionette.Behavior {
  defaults() {
    return {
      opts: {
        toggle: true,
      },
    };
  }

  onRender() {
    this.$el.metisMenu(this.options.opts);
  }
}

export { MetisMenu as default };
